import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: ['mbs'],
        },
    },
});
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
